
import React, { useState, useRef, useEffect } from 'react';
import './TopBar.css';

// 支持的音频检测语言列表
const SUPPORTED_LANGUAGES = [
  { code: 'zh', name: '中文', flag: '🇨🇳' },
  { code: 'en', name: '英语', flag: '🇺🇸' },
  { code: 'ja', name: '日语', flag: '🇯🇵' },
  { code: 'es', name: '西班牙语', flag: '🇪🇸' },
  { code: 'fr', name: '法语', flag: '🇫🇷' },
  { code: 'de', name: '德语', flag: '🇩🇪' },
];

type TopBarProps = {
  userName?: string;
  onLogout?: () => void;
  currentView: 'analyze' | 'records';
  onViewChange: (view: 'analyze' | 'records') => void;
};

export const TopBar: React.FC<TopBarProps> = ({ userName, onLogout, currentView, onViewChange }) => {
  const [showLangList, setShowLangList] = useState(false);
  const langDropdownRef = useRef<HTMLDivElement>(null);

  // 点击外部关闭下拉菜单
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (langDropdownRef.current && !langDropdownRef.current.contains(event.target as Node)) {
        setShowLangList(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  return (
    <header className="topbar">
      <div className="topbar-left">
        <div className="topbar-logo-orbit">
          <div className="topbar-logo-core" />
        </div>
        <div className="topbar-product">
          <div className="topbar-title">TPCN GenAI Lab.</div>
          <div className="topbar-sub">智能语音质检 </div>
        </div>
      </div>
      <div className="topbar-right">
        <div className="topbar-pill topbar-pill-outline">
          <span className="topbar-status-dot" />
        </div>
        <div className="topbar-divider" />
        <div className="topbar-links">
          <button
            className={`topbar-link-btn ${currentView === 'records' ? 'topbar-link-active' : ''}`}
            type="button"
            onClick={() => onViewChange('records')}
          >
            质检总览
          </button>
          <button
            className={`topbar-link-btn ${currentView === 'analyze' ? 'topbar-link-active' : ''}`}
            type="button"
            onClick={() => onViewChange('analyze')}
          >
            语音质检
          </button>
        </div>

        {/* 音频检测支持语言列表 */}
        <div className="topbar-divider" />
        <div className="topbar-lang-section" ref={langDropdownRef}>
          <button
            className="topbar-lang-btn"
            type="button"
            onClick={() => setShowLangList(!showLangList)}
            title="支持的检测语言"
          >
            <span className="topbar-lang-icon">🌐</span>
            <span className="topbar-lang-text">支持语言</span>
            <span className={`topbar-lang-arrow ${showLangList ? 'open' : ''}`}>▼</span>
          </button>
          {showLangList && (
            <div className="topbar-lang-dropdown">
              <div className="topbar-lang-dropdown-header">
                音频检测支持语言
              </div>
              <div className="topbar-lang-list">
                {SUPPORTED_LANGUAGES.map((lang) => (
                  <div key={lang.code} className="topbar-lang-item">
                    <span className="topbar-lang-flag">{lang.flag}</span>
                    <span className="topbar-lang-name">{lang.name}</span>
                    <span className="topbar-lang-code">{lang.code}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
        {userName && (
          <>
            <div className="topbar-divider" />
            <div className="topbar-user">
              <div className="topbar-user-avatar">
                {userName.charAt(0).toUpperCase()}
              </div>
              <div className="topbar-user-meta">
                <div className="topbar-user-name">{userName}</div>
                <div className="topbar-user-role">质检员</div>
              </div>
            </div>
            {onLogout && (
              <button 
                className="topbar-logout-btn"
                type="button"
                onClick={onLogout}
              >
                退出
              </button>
            )}
          </>
        )}
      </div>
    </header>
  );
};
